import * as yup from 'yup';

export const EnabledSubjectsSchema = yup.object().shape({
  period_id: yup
    .number()
    .required('students.subjects.available.period.required')
    .min(1, 'students.subjects.available.period.required'),
});
